import Cookies from 'js-cookie';

const {
  VITE_PLATFORM_URL: domain,
  VITE_SYSTEM_PLATFORM_URL,
  MODE: mode,
  // @ts-ignore
} = import.meta.env;

export function setCookie(name: string, value: string) {
  Cookies.set(name, value);
}

export function removeCookie(name: string) {
  Cookies.remove(name);
}

export function getCookie(name: string) {
  return Cookies.get(name);
}

function getTokenRolePrefix() {
  const isSystem = domain === VITE_SYSTEM_PLATFORM_URL;
  return isSystem ? 'sa' : 'u';
}

export function getSessionTokenCookie() {
  const rolePrefix = getTokenRolePrefix();
  const isDev = mode === 'development';
  const isState = domain.indexOf('stage') > -1;
  if (isDev) {
    return getCookie(`dev_${rolePrefix}_t`);
  }
  if (isState) {
    return getCookie(`stage_${rolePrefix}_t`);
  }
  return getCookie(`${rolePrefix}_t`);
}
